import {
    REGISTER_SUCCESS,
    REGISTER_FAIL,
    LOGIN_SUCCESS,
    LOGIN_FAIL,
    LOGOUT,
    SET_MESSAGE,
    SET_REFRESH_TOKEN,
    SET_ACCESS_TOKEN,
    SET_USER,

  } from "./types";
  
  import AuthService from "../service/auth-service";
  
  export const register = (email, password,password1) => (dispatch) => {
    if (password !==password1){
      dispatch({
        type: REGISTER_FAIL,
      });
      dispatch({
        type: SET_MESSAGE,
        payload: "Неправильний пароль"
      });
      setTimeout(() => {
        dispatch({
          type: SET_MESSAGE,
          payload:false,
        });
      }, "5000")
      return Promise.reject();
    }
    return AuthService.register(email, password).then(
      (response) => {
        dispatch({
          type: REGISTER_SUCCESS,
        });
  
        if(response.data?.message){
          dispatch({
            type: SET_MESSAGE,
            payload: response.data.message,
          });
          if(response.refreshToken){
          dispatch({
            type: LOGIN_SUCCESS,
            payload: { user: data },
          });
        }
    }
   
        setTimeout(() => {
          dispatch({
            type: SET_MESSAGE,
            payload:false,
          });
        }, "5000")
        return Promise.resolve();
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
  
        dispatch({
          type: REGISTER_FAIL,
        });
  
        dispatch({
          type: SET_MESSAGE,
          payload: message,
        });
        setTimeout(() => {
          dispatch({
            type: SET_MESSAGE,
            payload:false,
          });
        }, "5000")
        return Promise.reject();
      }
    );
  };
  
  export const setMessage = (type, payload) =>(dispatch) => {
   
    dispatch({
      type,
      payload,
    });
    setTimeout(() => {
      dispatch({
        type,
        payload:false,
      });
    }, "5000")
  }

  export const login = (email, password) => (dispatch) => {
    return AuthService.login(email, password).then(
      (data) => {
        dispatch({
          type: LOGIN_SUCCESS,
          payload: { user: data },
        });
  
        return Promise.resolve();
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
           
        dispatch({
          type: LOGIN_FAIL,
        });
  
        dispatch({
          type: SET_MESSAGE,
          payload: message,
        });
        setTimeout(() => {
          dispatch({
            type: SET_MESSAGE,
            payload:false,
          });
        }, "5000")
        return Promise.reject();
      }
    );
  };

  export const loginGoogle = (googleData) => (dispatch) => {
    return AuthService.loginGoogle(googleData).then(
      (data) => {
        if(data.accessToken){
        dispatch({
          type: LOGIN_SUCCESS,
          payload: { user: data },
        });
      }
        return Promise.resolve();
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
           
        dispatch({
          type: LOGIN_FAIL,
        });
  
        dispatch({
          type: SET_MESSAGE,
          payload: message,
        });
        setTimeout(() => {
          dispatch({
            type: SET_MESSAGE,
            payload:false,
          });
        }, "5000")
        return Promise.reject();
      }
    );
  };



  export const recoveryPassword = (email) => (dispatch) => {
    return AuthService.recovery(email).then(
      () => {
        return Promise.resolve();
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();  
        return Promise.reject();
      }
    );
  };

  export const recoverySetNewPassword = (email,password,token) => (dispatch) => {
  
    return AuthService.recovery(email,password,token).then(
      (data) => {
        return data;
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
           
        return error;
        return Promise.reject();
      }
    );
  };
  
  
  export const setRefreshToken = (refreshToken) => (dispatch) => {
    dispatch({
      type: SET_REFRESH_TOKEN,
      payload: refreshToken,
    })
  }
  export const setAccessToken = (accessToken) => (dispatch) => {
    dispatch({
      type: SET_ACCESS_TOKEN,
      payload: accessToken,
    })
  }

  export const logout = () => (dispatch) => {
    AuthService.logout();
  
    dispatch({
      type: LOGOUT,
    });
  };


  export const updateUser = (data) => (dispatch) => {  
    const user = JSON.parse(localStorage.getItem("user"));
    if (data.phone &&  data.name &&  data.city_id){
      user.user.registrationSucesseful = true;
      user.user.name = data.name;
      user.user.cityId =data.city_id;
      localStorage.setItem("user", JSON.stringify(user));
      dispatch({
        type: SET_USER,
        payload: user,
      });
    }
   
   
    

   
  };


